var me = Object.defineProperty, pe = Object.defineProperties;
var fe = Object.getOwnPropertyDescriptors;
var O = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, V = Object.prototype.propertyIsEnumerable;
var H = (r, i, l) => i in r ? me(r, i, { enumerable: !0, configurable: !0, writable: !0, value: l }) : r[i] = l, I = (r, i) => {
  for (var l in i || (i = {}))
    N.call(i, l) && H(r, l, i[l]);
  if (O)
    for (var l of O(i))
      V.call(i, l) && H(r, l, i[l]);
  return r;
}, P = (r, i) => pe(r, fe(i));
var _ = (r, i) => {
  var l = {};
  for (var s in r)
    N.call(r, s) && i.indexOf(s) < 0 && (l[s] = r[s]);
  if (r != null && O)
    for (var s of O(r))
      i.indexOf(s) < 0 && V.call(r, s) && (l[s] = r[s]);
  return l;
};
import { jsxs as a, jsx as t } from "react/jsx-runtime";
import de from "@tiptap/extension-bold";
import he from "@tiptap/extension-bullet-list";
import ge from "@tiptap/extension-character-count";
import ke from "@tiptap/extension-document";
import Ce from "@tiptap/extension-history";
import ye from "@tiptap/extension-italic";
import Te from "@tiptap/extension-link";
import xe from "@tiptap/extension-list-item";
import Le from "@tiptap/extension-ordered-list";
import ve from "@tiptap/extension-paragraph";
import Ee from "@tiptap/extension-strike";
import Oe from "@tiptap/extension-text";
import Ie from "@tiptap/extension-underline";
import { useEditor as je, EditorContent as Se } from "@tiptap/react";
import be from "emoji-picker-react";
import o from "../../../node_modules/prop-types/index.es.js";
import { useState as T, useEffect as Z, useCallback as m } from "react";
import { COMPONENT_SIZE as J } from "../../../constants/sizes.es.js";
import { STATUS_COLOR as j } from "../../../constants/status.es.js";
import { helper as Me } from "./helper.es.js";
import * as Ue from "./style.es.js";
import { TextEditorWrapper as we, Editor as Pe, Label as Re, Required as $e, Menu as ze, MenuPrefixes as Be, MenuPrefixesItem as We, MenuButton as h, EmojiWrapper as qe, LinkWrapper as Ae, LinkInputWrapper as Fe } from "./style.es.js";
import { Icon as g } from "../../DataDisplay/Icon/Icon.es.js";
import { Typography as He } from "../../Typography/Typography.es.js";
import { Input as G } from "../Input/Input.es.js";
import { Button as Ne } from "../Button/Button.es.js";
import { Helper as Ve } from "../../DataDisplay/Helper/Helper.es.js";
function R(_e) {
  var W = _e, {
    value: r,
    label: i,
    required: l = !1,
    limit: s = 180,
    showCounter: $ = !1,
    showToolbar: K = !0,
    placeholder: Q,
    children: z,
    status: u,
    size: X = J.md,
    onChange: S,
    onBlur: b,
    helperText: B = "",
    isFocused: M,
    toolbarPrefixData: x
  } = W, Y = _(W, [
    "value",
    "label",
    "required",
    "limit",
    "showCounter",
    "showToolbar",
    "placeholder",
    "children",
    "status",
    "size",
    "onChange",
    "onBlur",
    "helperText",
    "isFocused",
    "toolbarPrefixData"
  ]);
  const e = je({
    extensions: [ke, Ce, ve, Oe, Te.extend({
      inclusive: !1
    }).configure({
      openOnClick: !1
    }), de, Ie, ye, Ee, he, xe, Le, ge.configure({
      limit: s
    })],
    content: r,
    onUpdate: ({
      editor: n
    }) => {
      (typeof u == "string" && u !== "error" || u === null) && U(j.success), S == null || S(n.getHTML());
    }
  }), [k, p] = T(!1), [c, L] = T({
    url: "",
    displayText: ""
  }), [C, v] = T(!1), [D, q] = T(!!M), [E, U] = T(u);
  Z(() => {
    u && U(u);
  }, [u]), Z(() => {
    M && (e == null || e.chain().focus().run());
  }, [M]);
  const ee = m(() => {
    if (k) {
      p(!1);
      return;
    }
    L({
      url: (e == null ? void 0 : e.getAttributes("link").href) || "",
      displayText: ""
    }), p(!0), v(!1);
  }, [e, k]), re = m(() => {
    var n, f, A;
    if (c.url) {
      let d = c.url.trim();
      try {
        new URL(d).protocol.match(/^(http|https):$/) || (d = `https://${d}`);
      } catch (y) {
        d = `https://${d}`;
      }
      (A = (f = (n = e == null ? void 0 : e.chain()) == null ? void 0 : n.focus()) == null ? void 0 : f.extendMarkRange("link")) == null || A.command(({
        tr: y,
        dispatch: ae
      }) => {
        if (!ae)
          return !0;
        const {
          from: w,
          to: ue
        } = y.selection, F = c.displayText || c.url || "";
        return y.insertText(F, w, ue), y.addMark(w, w + F.length, e.schema.marks.link.create({
          href: d
        })), !0;
      }).run();
    } else
      e == null || e.chain().focus().extendMarkRange("link").unsetLink().run();
    p(!1), L({
      url: "",
      displayText: ""
    });
  }, [e, c, p]), ne = m(() => {
    e == null || e.chain().focus().toggleBold().run();
  }, [e]), te = m(() => {
    e == null || e.chain().focus().toggleUnderline().run();
  }, [e]), oe = m(() => {
    e == null || e.chain().focus().toggleItalic().run();
  }, [e]), ie = m(() => {
    e == null || e.chain().focus().toggleStrike().run();
  }, [e]), le = ({
    text: n
  }) => {
    `${n} ${e == null ? void 0 : e.getText()}`.length > s || e == null || e.commands.insertContent(` ${n}`);
  }, se = i || Q, ce = m(() => {
    v(!C), p(!1);
  }, [C]);
  return e ? /* @__PURE__ */ a(we, { onBlur: (n) => {
    C || k || (b == null || b(n), U(void 0), q(!1));
  }, children: [
    /* @__PURE__ */ a(Pe, { status: E, isFocused: !!D, hasValue: !!r, children: [
      /* @__PURE__ */ a(Re, { children: [
        se,
        " ",
        l && /* @__PURE__ */ t($e, { children: "*" })
      ] }),
      /* @__PURE__ */ t(Se, I({ onFocus: () => {
        q(!0), k && p(!1), C && v(!1);
      }, editor: e }, Y)),
      K && /* @__PURE__ */ a(ze, { children: [
        !!(x != null && x.length) && /* @__PURE__ */ t(Be, { children: x.map((n) => /* @__PURE__ */ a(We, { active: !0, onClick: () => {
          e.chain().focus().insertContent(`{{${n.name}}} `).run();
        }, children: [
          /* @__PURE__ */ t(g, { name: "add", size: "sm" }),
          n.label
        ] }, n.name)) }),
        /* @__PURE__ */ t(h, { onClick: ee, variant: "link", children: /* @__PURE__ */ t(g, { name: "url", color: "currentColor" }) }),
        /* @__PURE__ */ t(h, { onClick: ne, variant: "link", children: /* @__PURE__ */ t(g, { name: "bold", color: "currentColor" }) }),
        /* @__PURE__ */ t(h, { onClick: oe, variant: "link", children: /* @__PURE__ */ t(g, { name: "italic", color: "currentColor" }) }),
        /* @__PURE__ */ t(h, { onClick: te, variant: "link", children: /* @__PURE__ */ t(g, { name: "underline", color: "currentColor" }) }),
        /* @__PURE__ */ t(h, { onClick: ie, variant: "link", children: /* @__PURE__ */ t(g, { name: "stroke", color: "currentColor" }) }),
        /* @__PURE__ */ a(h, { variant: "link", onClick: ce, style: {
          zIndex: 1e3,
          fontSize: 14
        }, children: [
          "🙂",
          /* @__PURE__ */ t(qe, { children: /* @__PURE__ */ t(be, { lazyLoadEmojis: !0, allowExpandReactions: !0, previewConfig: {
            showPreview: !1
          }, open: C, searchDisabled: !0, height: 300, onEmojiClick: (n) => {
            e.chain().focus().insertContent(n == null ? void 0 : n.emoji).run(), v(!1);
          } }) })
        ] })
      ] }),
      k && /* @__PURE__ */ a(Ae, { children: [
        /* @__PURE__ */ t(He, { variant: "body2Bold", children: "Insert Link" }),
        /* @__PURE__ */ a(Fe, { children: [
          /* @__PURE__ */ t(G, { onChange: (n) => L((f) => P(I({}, f), {
            displayText: n.target.value
          })), value: c.displayText, placeholder: "Display text" }),
          /* @__PURE__ */ t(G, { onChange: (n) => L((f) => P(I({}, f), {
            url: n.target.value
          })), value: c.url, inputProps: {
            required: !0
          }, placeholder: "URL address*" }),
          /* @__PURE__ */ t(Ne, { disabled: !Me.checkUrlInput(c.url), onClick: re, children: "Apply" })
        ] })
      ] })
    ] }),
    $ && /* @__PURE__ */ t(Ve, { maxLength: s, counter: e.storage.characterCount.characters(), error: E === j.error, size: X, success: E === j.success, text: B, showCounter: !!B || !!($ && s) }),
    z && z({
      value: r,
      limit: s,
      charCount: e.storage.characterCount.characters(),
      editorStatus: E,
      handlePaste: le,
      editorPlainText: e.getText()
    })
  ] }) : null;
}
R.S = Ue;
R.displayName = "TextEditor";
R.propTypes = {
  children: o.oneOfType([o.string, o.node]),
  placeholder: o.string,
  status: o.oneOf(Object.values(j)),
  size: o.oneOf(Object.values(J)),
  label: o.string,
  required: o.bool,
  value: o.string,
  limit: o.number,
  isFocused: o.bool,
  onChange: o.func,
  onBlur: o.func,
  showCounter: o.bool,
  helperText: o.oneOfType([o.string, o.node]),
  toolbarPrefixData: o.arrayOf(o.shape({
    name: o.string,
    label: o.string
  }))
};
export {
  R as TextEditor
};
//# sourceMappingURL=TextEditor.es.js.map
